<template>
  <div>
    <!-- Top Banner -->
    <!-- <div class="top-banner">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col notice">
                    <span>Buy one, get one 50% off books for all ages.</span>
                    <a href="#" class="ms-2">See All Offers ></a>
                </div>
                <div class="col-auto">
                    <div class="social-icons">
                        <a href="https://www.facebook.com/nilkhet.com.bd/" target="_blank"><font-awesome-icon icon="fab fa-facebook-f" /></a>
                        <a href="https://www.instagram.com/nilkhetbd" target="_blank" ><font-awesome-icon icon="fab fa-instagram" /></a>
                        <a href="https://wa.me/8801711086468" target="_blank" ><font-awesome-icon icon="fab fa-whatsapp" /></a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!-- Offcanvas Menu -->
    <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileMenu" aria-labelledby="mobileMenuLabel">
      <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="mobileMenuLabel">Menu</h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
          <div class="mb-4">
              <search-box />
              <router-link class="offcanvas-menu-item" to="/">
                  <font-awesome-icon class="offcanvas-icon" icon="fas fa-home" />
                  Home
              </router-link>
              <router-link class="offcanvas-menu-item" to="/search">
                  <font-awesome-icon icon="fas fa-book" />
                  All Books
              </router-link>
              <router-link class="offcanvas-menu-item" to="/category/?c=series">
                  <font-awesome-icon icon="fas fa-book" />
                  Series
              </router-link>
              <router-link class="offcanvas-menu-item" to="/orders">
                <font-awesome-icon icon="fas fa-shopping-bag" />
                My Orders
              </router-link>
              <router-link class="offcanvas-menu-item" :to="{ path: '/contact' }">
                  <font-awesome-icon icon="fas fa-envelope" />
                  Contact
              </router-link>
              <router-link 
                v-if="isLoggedIn" 
                class="offcanvas-menu-item" 
                to="#" 
                @click.prevent="logout"
              >
                <font-awesome-icon icon="fa-solid fa-right-from-bracket" />
                Logout
              </router-link>
          </div>
          
          <div class="border-top pt-4">
              <h6 class="mb-3 ps-3">Categories</h6>
              <a
                v-for="(category, index) in categories"
                :key="`category-${index}`"
                :href="'/search/?c=' + category.slug"
                class="offcanvas-menu-item"
              >
                <span class="category-text">
                  <i :class="category.icon" class="category-icon"></i>
                  {{ category.name }}
                </span>
              </a>
          </div>
      </div>
  </div>

    <!-- Header -->
    <nav class="navbar navbar-expand-lg header fixed-top navbar-bg-custom">
      <div class="container px-3">

        <!-- Top row for mobile -->
        <div class="d-flex w-100 d-lg-none justify-content-between align-items-center">
          <!-- Toggler (left) -->
          <button class="mobile-menu-toggle" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu">
            <font-awesome-icon icon="fas fa-bars" />
          </button>

          <!-- Centered brand on mobile -->
          <a class="navbar-brand position-absolute start-50 translate-middle-x logo" href="/">
            <img src="https://cdn-icons-png.flaticon.com/512/240/240191.png" alt="Book Store Logo" width="30" height="30">
            Nilkhet Books
          </a>

          <!-- Right-side button always visible -->
          <a href="#" class="text-dark position-relative ">
            <router-link
              class="nav-link"
              to="/cart"
            >
              <font-awesome-icon icon="fas fa-shopping-cart" />
              <span class="wishlist-count position-absolute top-0 start-100 translate-middle d-flex align-items-center justify-content-center badge bg-danger">
                {{ cartItemCount }}
              </span>
            </router-link>
          </a>
        </div>

        <!-- Brand on desktop -->
        <div class="d-none d-lg-flex align-items-center w-100">
          <!-- <a class="navbar-brand me-auto" href="#">Navbar</a> -->
          <a class="navbar-brand me-auto logo" href="/">
            <img src="https://cdn-icons-png.flaticon.com/512/240/240191.png" alt="Book Store Logo" width="30" height="30">
            Nilkhet Books
          </a>

          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav nav-main mx-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link class="nav-link" to="/">Home</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/search">All Books</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/category/?c=series">Series</router-link>
              </li>
              <!-- <li class="nav-item d-none d-xl-block">
                <router-link class="nav-link" to="/about">About</router-link>
              </li> -->
              <li class="nav-item">
                <router-link class="nav-link" :to="{ path: '/contact' }">Contact</router-link>
              </li>
              <li v-if="isLoggedIn" class="nav-item">
                <router-link class="nav-link" to="/orders">My Orders</router-link>
              </li>
              <!-- <li v-if="isLoggedIn" class="nav-item">
                <a class="nav-link" href="#" @click.prevent="logout">Logout</a>
              </li> -->
            </ul>
          </div>

          <!-- Right-side button on desktop -->
          <search-box v-if="showSearch" />
          <div v-else class="support-info text-end me-3">
            <span class="support-icon">
              <a href="tel:+8801711086468">
                <font-awesome-icon icon="fa fa-phone" />
              </a>
            </span>
            <div>
              <a href="tel:+8801711086468" class="support-number">+880 1711 086 468</a>
              <div class="support-text">24/7 Support Center</div>
            </div>
          </div>
          <a href="#" class="text-dark d-none d-lg-block me-3">
            <router-link class="nav-link" to="/profile">
              <font-awesome-icon icon="far fa-user" />
            </router-link>
          </a>
          <a href="#" class="text-dark position-relative d-none d-lg-block me-3">
            <router-link
              class="nav-link"
              to="/wishlist"
            >
              <font-awesome-icon icon="far fa-heart" />
              <span class="wishlist-count position-absolute top-0 start-100 translate-middle d-flex align-items-center justify-content-center badge bg-danger">
                {{ wishlistItemCount }}
              </span>
            </router-link>
          </a>
          <a href="#" class="text-dark position-relative d-none d-lg-block">
            <router-link
              class="nav-link"
              to="/cart"
            >
              <font-awesome-icon icon="fas fa-shopping-cart" />
              <span class="wishlist-count position-absolute top-0 start-100 translate-middle d-flex align-items-center justify-content-center badge bg-danger">
                {{ cartItemCount }}
              </span>
            </router-link>
          </a>
        </div>
      </div>
    </nav>



  </div>
</template>

<script>
import SearchBox from './SearchBox.vue';
export default {
  components: { SearchBox },
  name: "HeaderComponent",
  data() {
    return {
      categories: [
        {
          name: "Business",
          icon: "bi bi-briefcase",
          slug: "business",
        },
        {
          name: "Religion",
          icon: "bi bi-peace",
          slug: "religion",
        },
        {
          name: "Self Help",
          icon: "bi bi-emoji-smile",
          slug: "self_help",
        },
        {
          name: "Literature",
          icon: "bi bi-journal-bookmark",
          slug: "literature",
        },
        {
          name: "Science Fiction",
          icon: "bi bi-cpu",
          slug: "science_fiction",
        },
        {
          name: "Children & Teens",
          icon: "bi bi-people",
          slug: "children_and_teens",
        },
        {
          name: "Biographies & Memoirs",
          icon: "bi bi-person-lines-fill",
          slug: "biographies_and_memoirs",
        },
        {
          name: "Politics History and Tradition",
          icon: "bi bi-bank",
          slug: "politics_history_and_tradition",
        },
        {
          name: "Information and Technology",
          icon: "bi bi-motherboard",
          slug: "information_and_technology",
        },
        {
          name: "Stationery & Craft",
          icon: "bi bi-pencil-square",
          slug: "stationery_and_craft",
        },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    cartItemCount() {
      return this.$store.getters.cartItemCount;
    },
    wishlistItemCount() {
      return this.$store.getters.wishlistItemCount;
    },
    showSearch() {
      const allowedRoutes = ["/book"];
      return allowedRoutes.some(route =>
        this.$route.path.startsWith(route)
      );
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      window.location.reload();
    },
  },
};
</script>

<style lang='scss'>
.navbar-bg-custom {
  background-color: #fff;
}
/* ################ */
/* Adding new styles for mobile menu */
.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  padding: 5px;
}

.offcanvas {
  max-width: 300px;
}

.offcanvas-menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #eee;
  transition: all 0.3s;
}

.offcanvas-menu-item:hover {
  background-color: #f8f9fa;
  color: var(--primary-color);
}

.offcanvas-menu-item svg {
  margin-right: 12px;
  width: 20px;
  text-align: center;
}

.category-text {
  font-size: 15px;
  font-weight: 400;
}

.category-icon {
  margin-right: 5px;
  opacity: 0.5;
  font-size: 18px;
}

.category-link:hover .category-icon {
  opacity: 1;
}

/* ############## */
/* Top Banner */

.top-banner {
  background-color: var(--secondary-color);
  padding: 10px 0;
  font-size: 12px;
  font-weight: 300;
  color: white;
}

.top-banner a {
  color: white;
  text-decoration: none;
}

.social-icons a {
  margin-left: 15px;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.social-icons a:hover {
  opacity: 1;
}

/* ################## */
/* Header */

.header {
  padding: 20px 0;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  font-weight: 700;
  color: #333;
  text-decoration: none;
}

.logo:hover {
  color: var(--primary-color);
}

.nav-main .nav-link {
  color: #333;
  padding: 0 15px;
  font-weight: 500;
}

.nav-main .nav-link.active {
  color: var(--primary-color);
}

.nav-main .nav-link:hover {
  color: var(--primary-color);
}

.support-info {
  display: flex;
  align-items: center;
}
.support-icon {
  width: 40px;
  height: 40px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: rgba(102, 102, 102, 0.1);
  margin-right: 10px;
  a {
    color: #333;
  }
}

.support-number {
  color: var(--primary-color);
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
  text-decoration: none;
}

.support-text {
  font-size: 12px;
  color: var(--text-gray);
}

.wishlist-count {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  font-size: 10px;
}

/* #################### */
/* Responsive Adjustments */
@media (max-width: 991px) {
  .mobile-menu-toggle {
      display: block;
  }
  .nav-main {
      display: none;
  }
}

@media (max-width: 767px) {
  .logo {
    font-size: 20px;
    img {
      width: 20px;
      height: auto;
    }
  }
  .top-banner .notice {
        display: none;
    }
  .support-info {
      display: none;
  }
  .categories-toggle {
      display: none;
  }
}
</style>
